module.exports = __webpack_public_path__ + "static/media/G1141311_Korea-02.4c05565d.png";